<template>
    <div class="row content-box full-height 1234">
      <router-view />
    </div>
  </template>
  
<script>

export default {
   
};
</script>
  